"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldHidePendingBalance = void 0;
var pay_api_1 = require("@l2p/pay-api");
var ONE_HOUR_MS = 60 * 60 * 1000;
var shouldHidePendingBalance = function (pendingBalance, lastTransaction) {
    if (!pendingBalance || !(lastTransaction === null || lastTransaction === void 0 ? void 0 : lastTransaction.createdAt))
        return false;
    var createdAt = new Date(lastTransaction.createdAt).getTime();
    var isRecent = Date.now() - createdAt < ONE_HOUR_MS;
    var isCompletedOrAccepted = lastTransaction.status === pay_api_1.TransactionStatusEnum.Completed ||
        lastTransaction.status === pay_api_1.TransactionStatusEnum.Accepted;
    return !isRecent && isCompletedOrAccepted;
};
exports.shouldHidePendingBalance = shouldHidePendingBalance;
